import React, { useState } from "react";
import Grid from "@mui/material/Grid";

//Components
import Budget from "../../Components/Budget";


const BudgetList = () => {
  return (
    <>
      <Grid container>
        <Grid item xs={12} style={{ marginTop: "0px", height: "90vh" }}>
          <Budget />
        </Grid>
      </Grid>

    </>
  );
};

export default BudgetList;
